export default __webpack_public_path__ + "static/media/spices1.ab098921.jpg";